import {
    Controller
} from "stimulus"

/**
 * Controller for flyout search.
 */
export default class extends Controller
{
    static targets = ['collapse', 'field']

    get form()
    {
        return this.element.querySelector('form')
    }

    get field()
    {
        return this.element.querySelector('input[type=search]')
    }

    connect()
    {
        this.field.setAttribute('required', true)
        this.field.setAttribute('aria-label', 'Search')
        this.field.addEventListener("keyup", this.handleKeyPress.bind(this))
    }

    handleKeyPress(e)
    {
        if (e.keyCode === 13) {
            e.preventDefault()
            this.form.submit()
        }
    }

    focus()
    {
        window.setTimeout(() =>  this.field.focus(), 100)
    }

    disconnect()
    {
        this.field.addEventListener(this.field, "keypress", this.handleKeyPress.bind(this))
    }
}
